import {AxiosResponse} from "axios/index";
import $api from "../../../http";

export function confirmEmail(token: string): Promise<AxiosResponse> {
    return $api.post(`/auth/email/confirm/${token}`, {}, {validateStatus: null})
}